import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeQuartz } from 'ag-grid-community';
import '../../config/agGridConfig'; // Register AG Grid modules
import { adminAPI } from '../../services/api';
import '../../styles/AdminGlobal.css';
import './Admin.css';

const TranslationManagement: React.FC = () => {
  const [translations, setTranslations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const columnDefs: ColDef[] = [
    { field: 'key', headerName: 'Key', sortable: true, filter: true, width: 250 },
    { field: 'category', headerName: 'Category', sortable: true, filter: true, width: 120 },
    { field: 'text_en', headerName: 'English', editable: true, flex: 1 },
    { field: 'text_bn', headerName: 'Bangla', editable: true, flex: 1 },
    { 
      headerName: 'Actions',
      width: 100,
      cellRenderer: (params: any) => (
        <button 
          className="edit-btn" 
          onClick={() => handleSave(params.data)}
        >
          Save
        </button>
      )
    }
  ];

  useEffect(() => {
    loadTranslations();
  }, []);

  const loadTranslations = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getTranslations();
      const data = response.data || response;
      const translationsList = Array.isArray(data) ? data : (data as any).results || [];
      setTranslations(translationsList);
    } catch (error) {
      console.error('Failed to load translations:', error);
      setTranslations([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data: any) => {
    try {
      await adminAPI.updateTranslation(data.id, {
        text_en: data.text_en,
        text_bn: data.text_bn
      });
      alert('Translation updated!');
    } catch (error) {
      console.error('Failed to update translation:', error);
      alert('Failed to update translation.');
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  // Ensure translations is always an array before filtering
  const translationsArray = Array.isArray(translations) ? translations : [];
  const filteredTranslations = translationsArray.filter(translation =>
    translation.key?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    translation.text_en?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    translation.text_bn?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-page">
      <div className="management-header">
        <div>
          <h3>Translation Management</h3>
          <p>Manage bilingual content translations</p>
        </div>
        <div className="management-actions">
          <button className="btn btn-secondary">Export</button>
          <button className="btn btn-primary">Import</button>
          <button className="btn btn-secondary" onClick={loadTranslations}>
            🔄 Refresh
          </button>
        </div>
      </div>
      
      <div className="ag-grid-wrapper">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search translations by key or text..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
        <div className="results-info">
          <span>{filteredTranslations.length}</span> translations found
        </div>
      
        <div className="ag-grid-container">
          <AgGridReact

            theme={themeQuartz}
            rowData={filteredTranslations || []}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={20}
            loading={loading}

            defaultColDef={{
              resizable: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TranslationManagement;
